<template>
  <div class="container">
    <div class="d-flex align-items-center my-5" v-if="loading">
      <div class="spinner-border text-danger" role="status"></div>
      <div class="ms-3">
        <strong>Loading...</strong>
      </div>
    </div>
    <div class="my-5" v-if="!loading">
      <strong>Singapore</strong><br/>
      Registered Attendees: {{ selectedCustomers.length }}<br/>
      Checked-in: {{ checkedin.length }} ({{ Math.round(checkedin.length / selectedCustomers.length * 100) }}%)
    </div>
    <div class="overflow-auto">
    <table
      class="table table-hover align-middle"
      v-if="selectedCustomers.length > 0"
      style="margin-bottom:405px;"
    >
      <thead>
        <tr>
          <th scope="col">Name</th>
          <th scope="col">Mobile number</th>
          <th scope="col">Attendance check in</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="customer in selectedCustomers" :key="customer.SK">
          <td>{{ customer.Name?.S }}</td>
          <td>{{ processPhoneNumber(customer.MobileNumber?.S) }}</td>
          <td>
            <template v-if="customer.EventCheckIn?.S == 'yes'">{{ customer.EventCheckIn?.S }}</template>
            <template v-else><router-link :to="`/bycode/${customer.EventConfirmationCode?.S}`">Check-in</router-link></template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { DateTime } from "luxon";
import { API } from "aws-amplify";
import * as _ from "lodash";

export default {
  name: "EventRegistration",
  components: {},
  data: () => ({
    loading: false,
    selectedCustomers: [],
  }),
  computed: {
    checkedin() {
      return _.filter(this.selectedCustomers, {
        EventCheckIn: {
          S: 'yes'
        }
      })
    },    
  },
  mounted() {
    this.loading = true;
    
    const apiName = "attendance";
    const path = "/getAllRegistration";
    API.get(apiName, path).then(r => {
      this.loading = false;
      this.selectedCustomers = _.filter(_.sortBy(r, s => this.processPhoneNumber(s.MobileNumber?.S)), { PaymentStatus: { S: 'paid'}})
    })
  },
  watch: {},
  methods: {
    modTime(dt) {
      return dt.split("T")[1] == "99:99"
        ? DateTime.fromISO(
            dt.split("T")[0]
          ).toLocaleString(DateTime.DATE_MED) + " (No birth time)"
        : DateTime.fromISO(dt).toLocaleString(
            DateTime.DATETIME_MED
          );
    },
    processPhoneNumber(num) {
      if (num) {
        return String(num).replaceAll(' ', '')
      } else {
        return '';
      }      
    },
  },
};
</script>

<style scoped>
@media (max-width: 991.98px) {
  .custom-mobile-text {
    font-size: 0.9rem;
  }
  .page-header {
    margin-top: -8px;
  }
}

.services-container {
  color: #939597;
}
.services-container h5.card-title {
  color: #75787b;
}
.services-container h5.card-title-blue {
  color: #003a70;
}
.services-container h5.date {
  color: #939597;
  font-size: 0.85rem;
}
.services-container .card-text {
  font-size: 0.8rem;
}
.services-container h5 {
  font-size: 1.1rem;
}
</style>
